import React from 'react';
import Title from '../../../../../@casino/ui/title';
import {useFormik, FormikContext} from "formik";
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import {setPostResultDenomination} from '../../store/thunk/setPostResultDenomination';
import { useRouter } from '../../../../../@casino/useRouter';
import { setGetViewGameFreespin } from '../../store/thunk/setGetViewGameFreespin';
import { setPostUpdateGameFreespin } from '../../store/thunk/setPostUpdateGameFreespin';
import { setPostUpdateStatus } from '../../store/thunk/setPostUpdateStatus';

const useStyles = makeStyles(() => ({
    flex: {
        display: 'flex'
    },
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%', 
    },
}))

const EditGameFreespin = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const router = useRouter();

    const {id} = router.query;

    React.useEffect(() => {
        dispatch(setGetViewGameFreespin({
            id
        }))
    }, [id]);

    const initialValues = useSelector(state => state.freespinGame.view);

    const onSubmit = (store) => {
        dispatch(setPostUpdateGameFreespin(store));
    }
    const enableReinitialize = true
    const formik = useFormik({onSubmit, initialValues, enableReinitialize});

    return (
        <div style={{padding: '0 20px'}}>
            <Title label="Изменение фриспина"/>
            <div style={{
                padding: '20px',
                background: '#1b2039',
                alignItems: 'center',
                borderRadius: '8px',
            }}>
                <FormikContext.Provider value={formik}>
                    <form 
                        onSubmit={formik.handleSubmit}
                    >
                        <div className={classes.flex}>
                            <label htmlFor="uuid" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                {!formik.values.currency && <span className={classes.helper} style={{color: 'red'}}>Для того, что бы получить деноминацию выберите сначала валюту</span>}
                                <span className={classes.helper}>Получить деноминацию по игре</span>
                                <input 
                                    type="text" 
                                    name="uuid" 
                                    id="uuid" 
                                    className={classes.text} 
                                    value={formik.values.uuid} 
                                    onChange={(v) => formik.setFieldValue('uuid', v.target.value)}/>
                            </label>
                            <div style={{display: 'flex', alignItems: 'center', marginLeft: 20}}>  
                                <span style={{
                                        color: 'rgb(36, 38, 62)',
                                        border: '1px solid rgb(255, 206, 1)',
                                        background: 'rgb(255, 206, 1)',
                                        cursor: 'pointer',
                                        padding: '5px 10px',
                                        overflow: 'hidden',
                                        fontSize: '14px',
                                        maxHeight: '48px',
                                        fontFamily: 'PT Sans, sans-serif',
                                        fontWeight: 400,
                                        userSelect: 'none',
                                        whiteSpace: 'nowrap',
                                        marginRight: '12px',
                                        borderRadius: '16px',
                                        textOverflow: 'ellipsis',
                                        textTransform: 'uppercase',
                                    }}
                                    onClick={() => dispatch(setPostResultDenomination({
                                        game_uuid: formik.values.uuid, 
                                        currency: formik.values.currency
                                    }))}
                                    >Проверить</span>
                                    <span style={{
                                        color: 'rgb(36, 38, 62)',
                                        border: '1px solid rgb(255, 206, 1)',
                                        background: 'rgb(255, 206, 1)',
                                        cursor: 'pointer',
                                        padding: '5px 10px',
                                        overflow: 'hidden',
                                        fontSize: '14px',
                                        maxHeight: '48px',
                                        fontFamily: 'PT Sans, sans-serif',
                                        fontWeight: 400,
                                        userSelect: 'none',
                                        whiteSpace: 'nowrap',
                                        marginRight: '12px',
                                        borderRadius: '16px',
                                        textOverflow: 'ellipsis',
                                        textTransform: 'uppercase',
                                    }}
                                    onClick={() => dispatch(setPostUpdateStatus({status: !initialValues.status, id: initialValues.id}))}
                                    >{initialValues.status ? 'Отключить' : 'Включить'}</span>
                            </div>
                        </div>  
                    <div style={{display: 'flex', flexDirection: 'column', columnGap: 12}}>
                        <div style={{width: '100%', display: 'flex', columnGap: 12}}>
                            <label htmlFor="bet_id" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Bet id</span>
                                <input 
                                    type="text" 
                                    name="bet_id" 
                                    id="bet_id" 
                                    className={classes.text} 
                                    value={formik.values.bet_id} 
                                    onChange={(v) => formik.setFieldValue('bet_id', v.target.value)}/>
                            </label>
                            <label htmlFor="denomination" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Denomination</span>
                                <input 
                                    type="text" 
                                    name="denomination" 
                                    id="denomination" 
                                    className={classes.text} 
                                    value={formik.values.denomination} 
                                    onChange={(v) => formik.setFieldValue('denomination', v.target.value)}/>
                            </label>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', columnGap: 12}}>
                            <label htmlFor="total_bet" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Total bet</span>
                                <input 
                                    type="text" 
                                    name="total_bet" 
                                    id="total_bet" 
                                    className={classes.text} 
                                    value={formik.values.total_bet} 
                                    onChange={(v) => formik.setFieldValue('total_bet', v.target.value)}/>
                            </label>
                            <label htmlFor="select" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Валюта</span>
                                <select 
                                    className={classes.text} 
                                    value={formik.values.currency} 
                                    onChange={(v) => formik.setFieldValue('currency', v.target.value)}
                                >
                                    <option value="RUB">RUB</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                </select>
                            </label>
                        </div>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>  
                        <span style={{
                            color: 'rgb(36, 38, 62)',
                            border: '1px solid rgb(255, 206, 1)',
                            background: 'rgb(255, 206, 1)',
                            cursor: 'pointer',
                            padding: '5px 10px',
                            overflow: 'hidden',
                            fontSize: '14px',
                            maxHeight: '48px',
                            fontFamily: 'PT Sans, sans-serif',
                            fontWeight: 400,
                            userSelect: 'none',
                            whiteSpace: 'nowrap',
                            marginRight: '12px',
                            borderRadius: '16px',
                            textOverflow: 'ellipsis',
                            textTransform: 'uppercase',
                        }}
                            onClick={() => formik.submitForm()}
                        >Сохранить игру</span>
                    </div>
                    </form>
                </FormikContext.Provider>
            </div>
        </div>
    )
}

export default EditGameFreespin;
